// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCpKHUOWHl1wwbYwgTC1cx3k2QurcLxLH8',
    libraries: 'places'
  }
})

Vue.config.productionTip = false
Vue.prototype.$scrollInto = (elementid) => {
  var element = document.getElementById(elementid)
  // console.log(elementid, element)
  var x = window.matchMedia('(max-width: 800px)')
  // console.log(x)
  if (x.matches) {
    var headerOffset = document.getElementsByTagName('header')[0].offsetHeight
    var elementPosition = element.getBoundingClientRect().top
    var offsetPosition = elementPosition - headerOffset
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  } else {
    element.scrollIntoView({block: 'start', behavior: 'smooth'})
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js